/**
 * The loading screen's words: its steps, Retry, the early development line, the tips (P1.9-T217: one shown per load,
 * each true of the game as it stands and approved by the author; `{key}` is the label of the player's own key for
 * the action the tip names, and the menu tip names Escape in its words since that key is fixed), and the notice of a load that failed, with the detail line under it.
 * A detail line is for whoever reports the failure and stays lower case with no full stop. `{title}` in
 * `failure.refusedCode` is `failure.refused`; `{code}` is a close code; `{awaited}` is the message the page waited
 * for, by its protocol name; `{seconds}` is a whole number; `{url}` is the address of a file and `{status}` the HTTP
 * status it answered.
 */
export const LOADING = {
  steps: {
    configuration: "Configuration",
    signIn: "Sign-in",
    world: "World pointer",
    manifests: "Manifests",
    atlas: "Atlas pages",
    character: "Character sheet",
    chunks: "Chunks",
    welcome: "The server's welcome",
    view: "Chunks around the camera",
  },
  retry: "Retry",
  tips: {
    sprint: "Sprint with {key}, held or toggled as you like.",
    interact: "Press {key} near a chest, a sign or a stranger.",
    bag: "Your bag, {key}, can sort itself.",
    map: "Lost? {key} opens the Map.",
    target: "{key} picks the nearest target.",
    stance: "{key} draws your weapon, or sheathes it.",
    itemNames: "Hold {key} to read the names of what lies on the ground.",
    emotes: "{key} opens the emote wheel. Not everything needs words.",
    chat: "{key} opens chat.",
    autoLoot: "Auto loot, in Settings, picks up what falls.",
    click: "With your weapon sheathed, a left click on a player shows their card.",
    minimap: "On the minimap, wary and hostile creatures wear different marks.",
    party: "Each member of your party has a colour of their own on your minimap.",
    menu: "Esc opens the menu.",
    zoom: "World zoom, in Settings, lets you see farther or closer.",
  },
  earlyDevelopment: "OdysseyTales is in early development. Things will change.",
  failure: {
    signIn: "Sign-in refused",
    world: "World not loaded",
    worldSentence: "Part of the world could not be loaded.",
    unreachable: "Server unreachable",
    unreachableSentence: "The server did not answer.",
    handoff: "The way is lost",
    handoffSentence: "Try again.",
    refused: "Server refused",
    refusedCode: "{title} ({code})",
    silence: "no {awaited} within {seconds} s",
  },
  file: {
    unanswered: "{url} did not answer",
    responded: "{url} responded {status}",
    unread: "{url} could not be read",
  },
} as const;
